import { useEffect } from "react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { useTranslation } from "react-i18next";

const FAQSection = () => {
    const { t } = useTranslation();
    const { ref, isVisible } = useScrollAnimation();

    const faqs = [
        { question: t('homepage.faq.q1.question'), answer: t('homepage.faq.q1.answer') },
        { question: t('homepage.faq.q2.question'), answer: t('homepage.faq.q2.answer') },
        { question: t('homepage.faq.q3.question'), answer: t('homepage.faq.q3.answer') },
        { question: t('homepage.faq.q4.question'), answer: t('homepage.faq.q4.answer') },
        { question: t('homepage.faq.q5.question'), answer: t('homepage.faq.q5.answer') },
        { question: t('homepage.faq.q6.question'), answer: t('homepage.faq.q6.answer') },
    ];

    useEffect(() => {
        const jsonLd = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: { '@type': 'Answer', text: faq.answer },
            })),
        };
        const el = document.createElement('script');
        el.type = 'application/ld+json';
        el.setAttribute('data-homepage-faq-jsonld', 'true');
        el.textContent = JSON.stringify(jsonLd);
        document.head.appendChild(el);
        return () => {
            el.remove();
        };
    }, [faqs]);

    return (
        <section
            ref={ref}
            className={`py-20 md:py-24 bg-background transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
        >
            <div className="max-w-3xl mx-auto px-6">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
                        {t('homepage.faq.title')}
                    </h2>
                    <p className="text-lg text-muted-foreground">
                        {t('homepage.faq.subtitle')}
                    </p>
                </div>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="bg-card rounded-2xl p-6 shadow-sm border border-border"
                        >
                            <h3 className="text-lg font-semibold text-foreground mb-2">
                                {faq.question}
                            </h3>
                            <p className="text-muted-foreground leading-relaxed">
                                {faq.answer}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
